exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".AllBoardsPage__title___1Y6dv {\n  margin-bottom: 20px;\n}\n.AllBoardsPage__boards___2GmaV {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.AllBoardsPage__board___2Mj-R {\n  margin: 0 20px 20px 0;\n  width: 400px;\n}\n", ""]);
// Exports
exports.locals = {
	"title": "AllBoardsPage__title___1Y6dv",
	"boards": "AllBoardsPage__boards___2GmaV",
	"board": "AllBoardsPage__board___2Mj-R"
};